
import { Component, Vue } from "vue-property-decorator";
import Cookies from 'js-cookie';

import { Network } from "@/network";

@Component<App>({
  components: {}
})
export default class App extends Vue {
  // private time = 60000;
  // private timeout = 600000;
  // private interval!: null | ReturnType<typeof setInterval>;
  // private current = +new Date();

  // public created() {
  //   this.interval = setInterval(() => {
  //     const now = +new Date();
  //     if (now - this.current > this.timeout) {
  //       this.current = +new Date();
  //       this.logout();
  //     }
  //   }, this.time);
  // }

  // public mounted() {
  //   document.addEventListener('click', this.updateCurrent);
  // }

  // private updateCurrent() {
  //   this.current = +new Date();
  // }

  // private logout() {
  //   if (window.location.href !== process.env.VUE_APP_BASE_URL + "/login") {
  //     Network.removeToken();
  //     Cookies.remove("appToken");
  //     Cookies.remove("appUserAuthPrivJson");
  //     Cookies.remove("loginType");
  //     Cookies.remove("appUserInfo");
  //     Cookies.remove("isAdmin");

  //     window.location.href = '/login';
  //   }
  // }
}
